export default __webpack_public_path__ + "static/media/card3.e4505582.png";